import client from '../../client';

export const GET_ROLES = 'GET_ROLES';

export function getUserRoles(userId) {
  return {
    type: GET_ROLES,
    promise: client.get(`users/${userId}/roles`),
  };
}



// WEBPACK FOOTER //
// ./src/common/auth/actions.js